import { LazyMotion as FramerLazyMotion, domAnimation } from 'framer-motion';

export type Props = {
  children: React.ReactNode;
};

export const LazyMotion = ({ children }: Props) => {
  return <FramerLazyMotion features={domAnimation}>{children}</FramerLazyMotion>;
};
